import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_API_URL } from '@cnt-workspace/data-access';
import { IListingRating } from '@curbnturf/entities';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'rating';

/** Ratings across every listing, which cnt-landing only ever fetches one listing at a time. */
@Injectable({ providedIn: 'root' })
export class AdminRatingApiService {
  private readonly http = inject(HttpClient);

  /** Every listing's rating rows, hidden ones and those on unpublished or deleted listings included. */
  listListingRatings(): Observable<IListingRating[]> {
    return this.http.get<IListingRating[]>(`${API_URL}/listing/admin/all`);
  }
}
